<template>
  <!-- KP-3919 kill switch. OFF renders the modal exactly as it shipped
       before; ON renders the picker that can deliver brand-catalogue files
       alongside the order form. -->
  <v2-download-catalog-modal-legacy
    v-if="!isBrandCatalogueEnabled"
    :show="show"
    :collection="collection"
    :retailer-id="retailerId"
    @close="$emit('close')"
  />
  <v2-modal
    v-else
    :show="show"
    title="Download Collection"
    size="sm"
    @close="$emit('close')"
  >
    <!-- Shared picker — offer whatever this collection actually has,
         individually or as one structured ZIP. -->
    <collection-download-picker
      :collection="collection"
      :retailer-id="retailerId"
      :downloading="downloading"
      @download="downloadCatalogue"
      @close-popup="$emit('close')"
    />
  </v2-modal>
</template>

<script>
import V2Modal from '@/components/v2/V2Modal.vue'
import CollectionDownloadPicker from '@/components/collection/CollectionDownloadPicker.vue'
import V2DownloadCatalogModalLegacy from '@/views/v2/collection/V2DownloadCatalogModalLegacy.vue'
import { useCollectionDownload } from '@/composables/useCollectionDownload'
import { useBrandCatalogueFlag } from '@/composables/useBrandCatalogueFlag'

export default {
  name: 'V2DownloadCatalogModal',
  components: { V2Modal, CollectionDownloadPicker, V2DownloadCatalogModalLegacy },
  props: {
    show: { type: Boolean, default: false },
    collection: { type: Object, default: () => null },
    retailerId: { type: String, default: null },
  },
  setup(props, { emit }) {
    return {
      ...useCollectionDownload({
        collectionId: () => props.collection && props.collection._id,
        retailerId: () => props.retailerId,
        onWholeCollection: () => emit('close'),
      }),
      ...useBrandCatalogueFlag(),
    }
  },
}
</script>
